import React, { useEffect, useState } from "react";
import "../Css/Services.css";
import { Link } from "react-router-dom";
import housemaid from "../assets/housemaid.jpg";
import cook from "../assets/cook.jpg";
import driver from "../assets/driver.jpg";
import japa from "../assets/japa.jpg";
import patient from "../assets/patient.jpg";
import babycare from "../assets/babycare.webp";

const Services = () => {
  const [index, setIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const minSwipeDistance = 50;

const onTouchStart = (e) => {
  setTouchEnd(null); // Reset for new gesture
  setTouchStart(e.targetTouches[0].clientX); 
};

const onTouchMove = (e) => {
  setTouchEnd(e.targetTouches[0].clientX);
};

const onTouchEnd = () => {
  if (!touchStart || !touchEnd) return;

  const distance = touchStart - touchEnd;
  const isLeftSwipe = distance > minSwipeDistance;
  const isRightSwipe = distance < -minSwipeDistance;

  if (isLeftSwipe) {
    nextSlide(); // Move forward
  } else if (isRightSwipe) {
    prevSlide(); // Move backward
  }
};
  

  // 🔥 ALL SERVICES HERE (easy to add more)
  const services = [
  {
    img: housemaid,
    title: "House Maid",
    path: "/services/house-maid-service-in-mumbai",
    desc:
      "SVK Maid Service provides reliable and professional house maids to keep your home organized, clean, and well managed.",
  },
  {
    img: cook,
    title: "Cooking Maid Service",
    path: "/services/cooking-service-in-mumbai",
    desc:
      "SVK Maid Service offers skilled cooking maids who prepare healthy, hygienic, and delicious meals for your family.",
  },
  {
    img: driver,
    title: "Driver Services",
    path: "/services/driver-service-in-mumbai",
    desc:
      "SVK Maid Service provides professional and trustworthy drivers to ensure safe, punctual, and comfortable travel.",
  },
  {
    img: japa,
    title: "Japa Maid",
    path: "/services/japa-maid-service-in-mumbai",
    desc:
      "Experienced Japa maids for newborn and mother care with complete hygiene and safety.",
  },
  {
    img: patient,
    title: "Patient Care",
    path: "/services/patient-care-service-in-mumbai",
    desc:
      "Trained patient care attendants providing compassionate support and assistance at home.",
  },
  {
    img: babycare,
    title: "Baby Care",
    path: "/services/baby-care-service-in-mumbai",
    desc:
      "Trusted baby care professionals ensuring safety, comfort, and proper care for your child.",
  },
];



  const getVisibleCards = () => {
  if (window.innerWidth <= 576) return 1;
  if (window.innerWidth <= 992) return 2;
  return 3;
};

const [visibleCards, setVisibleCards] = useState(getVisibleCards());

useEffect(() => {
  const handleResize = () => {
    setVisibleCards(getVisibleCards());
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);


  // 🔥 auto slide
  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) =>
        prev >= services.length - visibleCards ? 0 : prev + 1
      );
    }, 4000);

    return () => clearInterval(timer);
  }, [services.length]);

  const prevSlide = () => {
    setIndex((prev) =>
      prev === 0 ? services.length - visibleCards : prev - 1
    );
  };

  const nextSlide = () => {
    setIndex((prev) =>
      prev >= services.length - visibleCards ? 0 : prev + 1
    );
  };

  return (
    <section className="services">
      <div className="services-container">

        {/* Heading */}
        <div className="services-head">
          <span>OUR BEST SERVICES</span>
        </div>

        {/* Slider */}
        <div className="services-slider" onTouchStart={onTouchStart}
  onTouchMove={onTouchMove}
  onTouchEnd={onTouchEnd}>

          {/* Left Arrow */}
          <button className="services-arrow left" onClick={prevSlide}>
            ‹
          </button>

          {/* Track */}
          <div
            className="services-track"
            style={{
              transform: `translateX(-${index * (100 / visibleCards)}%)`,
transition: "transform 0.6s ease",
            }}
          >
            {services.map((item, i) => (
              <div className="service-slide" key={i}>
                <div className="service-card">
                  <img src={item.img} alt={item.title} />
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                  <Link to={item.path} className="service-btn">
                    READ MORE
                  </Link>

                </div>
              </div>
            ))}
          </div>

          {/* Right Arrow */}
          <button className="services-arrow right" onClick={nextSlide}>
            ›
          </button>

        </div>
      </div>
    </section>
  );
};

export default Services;
